import ImageView from '../../../../components/ui/ImageView/ImageView';
import MediaPlayer from '../../../../components/ui/MediaPlayer/MediaPlayer';
import utilsStyles from '../../../../styles/modules/utils.module.scss';
import type { ArticleBlock } from '../../types';
import styles from './ArticleBlocks.module.scss';

export interface ArticleBlocksProps {
  articleBlocks: Array<ArticleBlock>;
}

function ArticleBlocks({ articleBlocks }: ArticleBlocksProps) {
  return (
    <>
      {articleBlocks.map((block, index) => (
        // biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
        <div key={index} className={utilsStyles.mtSmall}>
          {articleBlock(block)}
        </div>
      ))}
    </>
  );
}

function articleBlock(block: ArticleBlock) {
  switch (block.type) {
    case 'body':
      return (
        <div
          className={`${styles.articleText} textHtml ${utilsStyles.mTopSmall}`}
          // biome-ignore lint/security/noDangerouslySetInnerHtml: <explanation>
          dangerouslySetInnerHTML={{ __html: formatBody(block.body) }}
        />
      );
    case 'file':
      return block.articleVideoUrl ? (
        <MediaPlayer src={block.articleVideoUrl} thumbnailUrl={block.articleImageUrl} />
      ) : (
        <ImageView src={block.articleImageUrl || ''} alt={'Image'} isFreeSize={true} />
      );
    default:
      return <></>;
  }
}

function formatBody(body?: string) {
  // リンクを新しいタブで開けるようにする
  if (!body) return '';
  const formattedBody = body.replace(/<a href="/g, '<a target="_blank" href="');
  return formattedBody;
}

export default ArticleBlocks;
